<template>
    <div>
        <div v-if="isAllImageAnswer">
            <div class="flex justify-center flex-wrap">
                <div class="m-2" :key="answer.id" v-for="answer in question.answers">
                    <div
                        @click.prevent="handleClickSelectAnswer(answer.initIndex)"
                        :style="{ 'background-image': 'url(' + answer.image + ')' }"
                        :class="{
                            'cursor-pointer bg-image bg-center bg-cover border-style flex items-center justify-center w-32 sm:w-48 h-32 sm:h-48': true,
                            'border-white border-3': selectedChoice.indexOf(answer.initIndex) < 0,
                            'border-red-light border-4': selectedChoice.indexOf(answer.initIndex) > -1,
                            'fade-answer-box': answer.title != ''
                        }"
                    >
                        <div
                            :class="{
                                'image-choice absolute px-4 truncate self-end pb-3 font-size-14 sm:font-size-18 text-white text-center w-32 sm:w-48': true
                            }"
                        >
                            {{ answer.title }}
                        </div>
                        <div
                            class="absolute icon-checked w-10 h-10 opacity-75"
                            v-if="selectedChoice.indexOf(answer.initIndex) > -1"
                        ></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="max-w-sm mx-auto height-answer" v-if="!isAllImageAnswer">
            <div v-for="(answer, index) in question.answers" :key="index" class="mb-3 flex flex-col items-center">
                <div
                    v-if="answer.image"
                    @click.prevent="handleClickSelectAnswer(answer.initIndex)"
                    :style="{ 'background-image': 'url(' + answer.image + ')' }"
                    :class="{
                        'cursor-pointer bg-image bg-center bg-cover border-style flex items-center justify-center w-32 sm:w-48 h-32 sm:h-48': true,
                        'border-white border-3': selectedChoice.indexOf(answer.initIndex) < 0,
                        'border-red-light border-4': selectedChoice.indexOf(answer.initIndex) > -1
                    }"
                >
                    <div
                        v-if="selectedChoice.indexOf(answer.initIndex) > -1"
                        class="icon-checked w-10 h-10 opacity-75"
                    ></div>
                </div>
                <div
                    v-if="!answer.image"
                    @click.prevent="handleClickSelectAnswer(answer.initIndex)"
                    :class="{
                        'theme-button inline-flex items-center btn btn-large select-none btn-block font-bold font-size-20 md:font-size-22 font-opensans shadow-text-none': true,
                        'btn-answer': selectedChoice.indexOf(answer.initIndex) < 0,
                        'system-button-selected':
                            selectedChoice.indexOf(answer.initIndex) > -1 && selectedChoice.length > 0 && isMultiple
                    }"
                >
                    <div
                        v-if="selectedChoice.indexOf(answer.initIndex) > -1 && selectedChoice.length > 0 && isMultiple"
                        class="fas fa-check-circle"
                    ></div>
                    <span class="flex-auto"> {{ answer.title }} </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sound from '@/lib/sound.js'

import pop from '@/assets/sounds/pop.mp3'

export default {
    props: {
        question: {
            type: Object,
            default: null
        },

        isAllImageAnswer: {
            type: Boolean,
            default: false
        },

        selectedChoice: {
            type: Array,
            default: null
        },

        isMultiple: {
            type: Boolean,
            default: false
        },

        isPlayAlone: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            sound: new Sound()
        }
    },

    created() {
        this.sound.registerSound({ id: 'pop', src: pop })
    },

    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('componentAlready'))
            }, 200)
        })
    },

    methods: {
        handleClickSelectAnswer(answerIndex) {
            if (this.isPlayAlone) {
                this.sound.play('pop')
            }
            this.$emit('selectAnswer', answerIndex)
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-large {
    padding: 0.6rem 1rem !important;
}

.height-answer {
    // overflow-y: auto;
    // height: 35vh;
}

@media screen and (min-width: 515px) and (max-width: 740px) {
    .btn-block {
        width: 480px;
    }
}

.fade-answer-box:before {
    content: '';
    border-radius: 0.45rem;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    text-align: center;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 70%);
}

.image-choice {
    color: var(--button-text-color);
}
</style>
